module.exports = __webpack_public_path__ + "static/media/olas.bc6da839.svg";